module.exports = __webpack_public_path__ + "media/assets/community/community-banner-88de072d4ceecbee255f9fcad4e7e820856868e15f6dda6aaa87fc3df777c69b.png";